<template>
  <div>
    <div class="flex items-center justify-between">
      <h2 class="font-medium text-lg sm:text-xl">
        <slot />
      </h2>
      <NamiButton
        v-if="!hideCloseButton"
        buttonType="secondary"
        text
        pill
        :icon="IconX"
        @buttonClick="$emit('close')"
      />
    </div>
    <p v-if="subtitle" class="text-xs text-neutral-600 dark:text-neutral-400">
      {{ subtitle }}
    </p>
    <NamiDivider class="mt-4" />
  </div>
</template>

<script setup lang="ts">
import { IconX } from "@tabler/icons-vue";

defineProps<{
  hideCloseButton?: boolean;
  subtitle?: string;
}>();

defineEmits<{
  (e: "close"): void;
}>();
</script>
